import { Transform, Type } from 'class-transformer';
import isEmpty from 'lodash/isEmpty';

import { SurveyAnswerItem } from './survey_answer_item';
export class SurveyAnswer {
  patternUuid?: string;

  patternName?: string;

  surveyUuid?: string;

  @Type(() => SurveyAnswerItem)
  @Transform((params) => params.value || [])
  items?: SurveyAnswerItem[];

  constructor(init?: Partial<SurveyAnswer>) {
    Object.assign(this, init);
  }

  // 全ての回答が空かどうかを判定
  // 一つでも回答が入っていればfalseを返す
  isAllEmptyAnswer(): boolean {
    return !Object.values(this.items!)
      .map(item => {
        const value = 'values' in item.answer! ? item.answer.values : item.answer?.value;
        return !isEmpty(value);
      })
      .reduce((prev, curr) => prev || curr, false);
  }
}
